import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { KeyboardArrowDown } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem, Popover } from '@mui/material';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { PRIMARY_PURPLE } from '../../../theme/colorConstants';
import { WEEKLY_DAILY_OPTIONS } from '../timekeepingConstants';

const DailyWeeklyDateSelector = ({ onChange }) => {
  const [datePickerAnchorEl, setDatePickerAnchorEl] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedType, setSelectedType] = useState(null);

  const menuRef = useRef(null);

  const open = Boolean(anchorEl);

  const handleOnOpenButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOnMenuClose = () => {
    setAnchorEl(null);
  };
  const handleOnDatePickerClose = () => {
    setDatePickerAnchorEl(null);
  };

  const handleDailyClick = () => {
    setSelectedType(WEEKLY_DAILY_OPTIONS.daily.value);
    setDatePickerAnchorEl(menuRef.current);
  };
  const handleWeeklyClick = () => {
    setSelectedType(WEEKLY_DAILY_OPTIONS.weekly.value);
    setDatePickerAnchorEl(menuRef.current);
  };

  const handleDateChange = useCallback(
    (date) => {
      onChange({ type: selectedType, date });
    },
    [onChange, selectedType]
  );

  const handleDatePickerClose = () => {
    setDatePickerAnchorEl(null);
    setAnchorEl(null);
    setSelectedType(null);
  };

  const weeklyDailyOpen = Boolean(datePickerAnchorEl);
  const weeklyDailyPopover = weeklyDailyOpen ? 'basic-menu' : undefined;

  return (
    <Box>
      <IconButton
        size="small"
        id="open-weekly-daily-filter-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOnOpenButtonClick}
      >
        <KeyboardArrowDown sx={{ color: PRIMARY_PURPLE[70] }} />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleOnMenuClose}>
        <div ref={menuRef}>
          <MenuItem
            selected={selectedType === WEEKLY_DAILY_OPTIONS.daily.value}
            onClick={handleDailyClick}
            value={WEEKLY_DAILY_OPTIONS.daily.value}
            aria-describedby="daily-menu-item"
          >
            {LanguageConverterV2(WEEKLY_DAILY_OPTIONS.daily.label)}
          </MenuItem>
          <MenuItem
            selected={selectedType === WEEKLY_DAILY_OPTIONS.weekly.value}
            onClick={handleWeeklyClick}
            value={WEEKLY_DAILY_OPTIONS.weekly.value}
            aria-describedby="weekly-menu-item"
          >
            {LanguageConverterV2(WEEKLY_DAILY_OPTIONS.weekly.label)}
          </MenuItem>
        </div>
      </Menu>

      <Popover
        id={weeklyDailyPopover}
        open={weeklyDailyOpen}
        anchorEl={datePickerAnchorEl}
        onClose={handleOnDatePickerClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StaticDatePicker
            disableFuture
            onChange={handleDateChange}
            closeOnSelect
            displayStaticWrapperAs="desktop"
            onClose={handleDatePickerClose}
            showToolbar={false}
            toolbarFormat=""
            renderInput={() => null}
          />
        </LocalizationProvider>
      </Popover>
    </Box>
  );
};
export default DailyWeeklyDateSelector;

DailyWeeklyDateSelector.propTypes = {
  onChange: PropTypes.func,
};
